const contentToggles = {
	mq: window.matchMedia('(max-width: 64.999em)'),
	elem: {
		$toggles:  document.querySelectorAll('[data-toggle]'),
	},

	init() {
		contentToggles.mq.addListener(contentToggles.initToggles);
		contentToggles.initToggles(contentToggles.mq);
	},

	initToggles() {
		contentToggles.elem.$toggles.forEach(function( el ) {
		   if(el.getAttribute( 'data-toggle-sm-only') === 'true') {
		    if(mq.matches) {
		      if(el.getAttribute( 'aria-expanded')) {
		        $(el).trigger('click');
		      }
		    } else {
		      if(el.getAttribute( 'aria-expanded') === 'false') {
		        $(el).trigger('click');
		      }
		    }
		   }
		}); 
	},

	closeAll() {
	  let toggles = document.querySelectorAll('[data-toggle][aria-expanded="true"]');
	  toggles.forEach(function( el ) {
	    el.click();
	  });
	},

	toggler(e) {
	  let el     = this,
	    newState = el.getAttribute( 'aria-expanded' ) === 'true' ? false : true,
	    swap     = function( el, hiding ) {
	      let target      = el.getAttribute( 'aria-controls' ),
	          targetEl    = document.querySelector( '#' + target );

	      if( el.getAttribute( 'data-toggle' ) === 'exclusive' ) {
	        contentToggles.closeAll();
	      }

				el.setAttribute( 'aria-expanded', hiding );
				targetEl.setAttribute( 'aria-hidden', !hiding );
			};

	  swap( el, newState );
	  e.preventDefault();
	},

	bindUIActions() {
		contentToggles.elem.$toggles.forEach(function( el ) {
		  el.addEventListener( 'click', contentToggles.toggler );
		});

		document.addEventListener('keyup', function( e ) {
		  if (e.keyCode === 27) { contentToggles.closeAll(); }
		});
	}
};

export { contentToggles };